<template>
    <b-table
        v-if="posts"
        :data="posts.data"
        :default-sort="[config.sort, config.sortDirection]"
        :loading="loading"
        class="postsTable table-striped my-table mt-4 has-background-color-dark"
        :mobile-cards="true"
        :per-page="posts.per_page"
        :show-detail-icon="true"
        :striped="true"
        :total="posts.total"
        backend-filtering
        backend-pagination
        backend-sorting
        paginated
        @sort="onSort"
        @page-change="onPageChange"
        @filters-change="onFilterChange"
        :trigger="changeColumnByScreenWidth()"
    >
        <b-table-column
            searchable
            field="id"
            label="#"
            sortable
            width="2%"
            type="is-primary"
        >
            <div slot="default" slot-scope="props">
                {{ props.row.reference }}
            </div>

            <div slot="searchable" slot-scope="props">
                <b-input
                    placeholder="Id..."
                    v-model="props.filters[props.column.field]"
                    size="is-small"
                ></b-input>
            </div>
        </b-table-column>

        <b-table-column
            width="80%"
            searchable
            field="title"
            :label="$t('post.list.post')"
            sortable
            :visible="isMobileOrTablet"
        >
            <div slot="default" slot-scope="props" class="w-3/4 md:w-full">
                <h3 class="titleTicket">
                    {{ props.row.title | truncate(100) }}
                </h3>
                <p
                    class="italic"
                    :inner-html.prop="props.row.content | truncate(100)"
                >
                    {{ props.row.content }}
                </p>
            </div>
            <div slot="searchable" slot-scope="props">
                <b-input
                    size="is-small"
                    placeholder="Titre..."
                    v-model="props.filters[props.column.field]"
                ></b-input>
            </div>
        </b-table-column>

        <b-table-column
            width="40%"
            searchable
            field="title"
            :label="$t('post.list.post')"
            sortable
            :visible="!isMobileOrTablet"
        >
            <div
                slot="default"
                v-if="props.row.title"
                slot-scope="props"
                class="titleTicket"
            >
                {{ props.row.title | truncate(100) }}
            </div>
            <div v-else></div>
            <div slot="searchable" slot-scope="props">
                <b-input
                    size="is-small"
                    placeholder="Titre..."
                    v-model="props.filters[props.column.field]"
                ></b-input>
            </div>
        </b-table-column>

        <b-table-column
            width="40%"
            searchable
            field="content"
            :label="$t('post.list.contents')"
            sortable
            :visible="!isMobileOrTablet"
        >
            <div
                v-if="props.row.content"
                slot="default"
                slot-scope="props"
                class="italic"
                :inner-html.prop="props.row.content | truncate(200)"
            >
                {{ props.row.content }}
            </div>
            <div v-else></div>
            <div slot="searchable" slot-scope="props">
                <b-input
                    placeholder="Contenu..."
                    v-model="props.filters[props.column.field]"
                    size="is-small"
                ></b-input>
            </div>
        </b-table-column>

        <b-table-column
            width="10%"
            field="unread_messages_count"
            :label="$t('post.list.not_read')"
        >
            <div slot="default" slot-scope="props">
                <b-tag
                    type="is-danger"
                    v-if="props.row.unread_messages_count > 0"
                >
                    {{ props.row.unread_messages_count }}
                </b-tag>
            </div>
        </b-table-column>

        <b-table-column :label="$t('post.list.actions')" width="3%">
            <div
                slot="default"
                slot-scope="props"
                class="max-w-max flex justify-center"
            >
                <b-button
                    class="viewPostBtn"
                    type="is-primary"
                    size="is-small"
                    tag="router-link"
                    :to="`/tickets/${props.row.id}`"
                >
                    <i class="fas fa-eye"></i>
                </b-button>
            </div>
        </b-table-column>
    </b-table>
</template>

<style scoped>
.titleTicket {
    font-weight: 500;
}
</style>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'PostsTable',
    data: function () {
        return {
            loading: false,
            isMobileOrTablet: false
        }
    },
    created() {
        this.loadAsyncData()
        window.addEventListener('resize', this.changeColumnByScreenWidth)
    },
    watch: {},
    computed: {
        ...mapState('post', {
            posts: (state) => state.posts,
            config: (state) => state.postsConfig
        }),
        ...mapState('auth', {
            isConnected: (state) => state.isConnected,
            weakConnection: (state) => state.weakConnection
        })
    },
    methods: {
        ...mapActions('post', ['getPosts', 'getPostsByToken']),

        loadAsyncData() {
            this.loading = true
            let endpoint
            if (this.isConnected) {
                endpoint = this.getPosts()
            } else {
                endpoint = this.getPostsByToken()
            }

            endpoint
                .catch((e) => {
                    this.$store.dispatch('toastError', e)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onSort(field, order) {
            this.config.sort = field
            this.config.sortDirection = order

            this.loadAsyncData()
        },
        onFilterChange(filter) {
            var filters = {}
            Object.keys(filter).forEach((element) => {
                filters[element] = filter[element]
            })
            this.config.filters = filters

            this.loadAsyncData()
        },
        onPageChange(page) {
            this.config.page = page

            this.loadAsyncData()
        },
        changeColumnByScreenWidth(e) {
            if (screen.width < 1024) {
                this.isMobileOrTablet = true
            } else {
                this.isMobileOrTablet = false
            }
        }
    },

    mounted() {}
}
</script>
